import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js/instance/sort";
import _flatMapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/flat-map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions, mapGetters } from "vuex";
import { MARK_DOCUMENT_CLASSIFICATIONS, UNMARK_DOCUMENT_CLASSIFICATIONS, EMPTY_MARKED_DOCUMENT_CLASSIFICATIONS, DOWNLOAD_ALL_PDF, SAVE_REQUEST_LIST, LOAD_REQUEST_LISTS, CLEAR_REQUEST_LIST } from "../../store/documents-actions";
import { showBModal } from "@Shared/components/bootstrap/BModal";
import PreviewCombinedModal from "../preview-combined/preview-combined-pdf-modal";
import RequestListModal from "./document-request-list/request-list-modal";
import SaveRequestListModal from "./modals/save-request-list-modal";
import ButtonBar from "@Shared/components/general/button-bar";
import { isEmpty, reduce } from "lodash";
import { defineComponent } from "@vue/composition-api";
import { DOCUMENTS_FOR_APPLICATION } from "../../store/documents-getters";
export default defineComponent({
  name: "DocumentsToolbar",
  components: {
    PreviewCombinedModal,
    RequestListModal,
    SaveRequestListModal,
    ButtonBar
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    clientDetails: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      previewCombinedModalVisible: false,
      saveRequestListModalVisible: false,
      savingRequestList: false,
      requestListData: [],
      preselectedRequestListName: ""
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters("ApplicationStore", ["getSubmissionHistory"])), mapGetters("DocumentsStore", [DOCUMENTS_FOR_APPLICATION])), {}, {
    submissions() {
      var _context;
      const submissionHistory = this.getSubmissionHistory;
      if (isEmpty(submissionHistory.byId)) return [];
      const allSubmissions = _mapInstanceProperty(_context = submissionHistory.allIds).call(_context, submissionId => submissionHistory.byId[submissionId]);
      return _Object$values(_reduceInstanceProperty(allSubmissions).call(allSubmissions, (acc, submission) => {
        if (submission.submissionMethod === "electronic" && (!acc[submission.lenderName] || new Date(acc[submission.lenderName].createdAt) < new Date(submission.createdAt))) {
          acc[submission.lenderName] = submission;
        }
        return acc;
      }, {}));
    }
  }, mapState("DocumentsStore", {
    DRAFT_TEMPLATE_NAME(state) {
      return state.DRAFT_TEMPLATE_NAME;
    },
    documentClassifications(state) {
      return state.classifications.byApplication[this.applicationId];
    },
    markedDocumentClassifications(state) {
      const markedIds = reduce(state.markedDocumentClassifications, (acc, value, key) => {
        if (this.documentClassifications.byId[key] && value) acc.push(key);
        return acc;
      }, []);
      return _sortInstanceProperty(markedIds).call(markedIds, (a, b) => {
        var _this$documentClassif, _this$documentClassif2, _this$documentClassif3, _this$documentClassif4;
        const orderA = (_this$documentClassif = (_this$documentClassif2 = this.documentClassifications.byId[a]) == null ? void 0 : _this$documentClassif2.customOrder) != null ? _this$documentClassif : 0;
        const orderB = (_this$documentClassif3 = (_this$documentClassif4 = this.documentClassifications.byId[b]) == null ? void 0 : _this$documentClassif4.customOrder) != null ? _this$documentClassif3 : 0;
        return orderA - orderB;
      });
    }
  })), {}, {
    totalClassifications() {
      return this.documentClassifications.allIds.length;
    },
    allDocumentsMarked: {
      get() {
        return this.totalClassifications && this.markedDocumentClassifications.length && this.totalClassifications === this.markedDocumentClassifications.length;
      },
      set(value) {
        if (value) this.markAllClassifications();else this.unMarkAllClassifications();
      }
    },
    canRequest() {
      return this.markedDocumentClassifications.length > 0;
    },
    canDownload() {
      var _context2;
      const classificationsMarkedWithDocuments = _flatMapInstanceProperty(_context2 = this.markedDocumentClassifications).call(_context2, documentClassificationId => this.documentClassifications.byId[documentClassificationId].documents);
      return classificationsMarkedWithDocuments.length;
    },
    filteredSubmissions() {
      var _context3;
      return _filterInstanceProperty(_context3 = this.submissions).call(_context3, submission => submission.docMethod && submission.docMethod !== null && submission.status !== "failed" && submission.submissionMethod !== "manual");
    },
    hasFilteredSubmission() {
      const documents = this.DOCUMENTS_FOR_APPLICATION(this.applicationId);
      return !isEmpty(this.filteredSubmissions) && _Object$keys(documents.byId).length;
    },
    hasSubmissions() {
      return !isEmpty(this.submissions);
    },
    firstLenderSubmissionStatus() {
      return this.submissions[this.submissions.length - 1].lenderBlocked;
    },
    lendersSubmissionStatus() {
      if (!this.hasSubmissions) return false;
      return this.firstLenderSubmissionStatus ? this.submissions.some(submission => !submission.lenderBlocked) : true;
    }
  }),
  mounted() {
    this.EMPTY_MARKED_DOCUMENT_CLASSIFICATIONS();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("DocumentsStore", [MARK_DOCUMENT_CLASSIFICATIONS, UNMARK_DOCUMENT_CLASSIFICATIONS, EMPTY_MARKED_DOCUMENT_CLASSIFICATIONS, DOWNLOAD_ALL_PDF, SAVE_REQUEST_LIST, LOAD_REQUEST_LISTS, CLEAR_REQUEST_LIST])), {}, {
    markAllClassifications() {
      this.MARK_DOCUMENT_CLASSIFICATIONS({
        markedDocumentClassifications: this.documentClassifications.allIds
      });
    },
    unMarkAllClassifications() {
      this.UNMARK_DOCUMENT_CLASSIFICATIONS({
        markedDocumentClassifications: this.documentClassifications.allIds
      });
    },
    transformClassificationsToRequestList(list) {
      return _mapInstanceProperty(list).call(list, ({
        classification,
        description
      }, order) => ({
        classification,
        description,
        order
      }));
    },
    showDocumentTemplateListModal() {
      showBModal("documents-template-list-modal", {}, this);
    },
    async showSaveListModal() {
      this.saveRequestListModalVisible = true;
      await this.$nextTick();
      this.$refs.requestListModal.$showModal();
    },
    async handlePreviewCombinedClick() {
      this.previewCombinedModalVisible = true;
      await this.$nextTick();
      this.$refs.previewCombinedModal.$showModal();
    },
    handleSaveAsTemplateClick() {
      this.requestListData = this.transformClassificationsToRequestList(_Object$values(this.documentClassifications.byId));
      this.showSaveListModal();
    },
    handleSaveAsRequestList({
      requestList
    }) {
      this.requestListData = this.transformClassificationsToRequestList(requestList);
      this.showSaveListModal();
    },
    async handleDownloadAsZip() {
      var _context4;
      const submitButton = _findInstanceProperty(_context4 = $(this.$refs.triggerDownloadButtonContainer)).call(_context4, ".dropdown-toggle");
      submitButton.animateButton().animate("start");
      await this.DOWNLOAD_ALL_PDF({
        applicationId: this.applicationId,
        clientUsername: this.clientUsername,
        classifications: this.markedDocumentClassifications
      });
      submitButton.animateButton().animate("finish");
    },
    async handleCreateRequestList({
      templateName
    }) {
      this.savingRequestList = true;
      await this.SAVE_REQUEST_LIST({
        documentRequestList: {
          name: templateName,
          draft: false
        },
        documentRequests: this.requestListData
      });
      this.clearDraftTemplate();
      this.preselectedRequestListName = this.DRAFT_TEMPLATE_NAME;
      this.savingRequestList = false;
    },
    clearDraftTemplate() {
      this.CLEAR_REQUEST_LIST({
        documentRequestListName: this.DRAFT_TEMPLATE_NAME
      });
    },
    handleRefresh() {
      this.$emit("refresh");
    },
    openBulkRequestModal() {
      showBModal("bulk-request-modal", {
        preselectRequestDocument: true,
        documentRequestIds: this.markedDocumentClassifications
      }, this);
    },
    openTagsModal() {
      this.$root.$emit("bv::hide::popover", "tagsPopover");
      this.$emit("openTags");
    },
    openDocumentsToLenderModal(submission) {
      this.$root.$emit("bv::hide::popover", "tagsPopover");
      this.$emit("openDocuments", submission);
    }
  })
});